import styled from "styled-components";

export const Video = styled.video`
  border-radius: 0px;
  z-index: 10;
  width: 100%;
`;
